import "./App.css";
import { firebaseConfig } from "./config/firebase";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { BrowserRouter } from "react-router-dom";
import Routes from "./components/Routes";
import { NotificationProvider } from "./context/NotificationContext";

function App() {
  // Initialize Firebase
  const app = initializeApp(firebaseConfig);

  // Initialize Analytics only in production and not in development
  if (process.env.NODE_ENV !== "development") {
    try {
      getAnalytics(app);
    } catch (error) {
      console.warn("Firebase Analytics initialization failed:", error);
    }
  }

  return (
    <BrowserRouter>
      <NotificationProvider>
        <Routes />
      </NotificationProvider>
    </BrowserRouter>
  );
}

export default App;
